import type { ConfirmationDetailsDto } from '@shared/core/events'
import { CONFIRMATION_DATE_TIME_FORMAT } from 'src/modules/confirmation/constants/cancellation-policy.constants'
import { formatInEventZone } from 'src/modules/confirmation/utils'
import type { PolicyStepCopy } from './cancellation-policy-step.interface'

/** The cutoff uses the same zone as the appointment line, so the two never disagree. */
export function resolvePolicyStepCopy(event: ConfirmationDetailsDto, businessFallback: string): PolicyStepCopy {
  const policy = event.cancellation_policy
  const policyText = policy?.policy_text?.trim() ? policy.policy_text : null
  return {
    business: event.business_name?.trim() || businessFallback,
    cutoffLabel: policy?.cutoff_at
      ? formatInEventZone(policy.cutoff_at, event.timezone, CONFIRMATION_DATE_TIME_FORMAT)
      : null,
    policyText,
  }
}
